//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'RMII',
  data() {
    return {
      defaultJson:{
        "Multilocular cyst": "卵巢多房囊肿",
        "Real region": "实性区域",
        "Transfer": "转移病灶",
        "ascites": "腹水",
        "Bilateral lesion": "双侧病变",
        "Menopausal state": "绝经状态（M）",
        "MenopausalStateLabel": "绝经后：1年以上没有月经的女性或50岁以上做过子宫切除术的女性。",
        "Serum CA125": "血清CA125"
      },
      form:{
        mc:'0',
        rr:'0',
        transfer:'0',
        ascites:'0',
        bl:'0',
        ms:'0',
        serum:'',
      },
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"1",name:'绝经前'},
        {value:"3",name:'绝经后'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        // RMI=U*M*CA125
        let U = form.mc + form.rr + form.transfer + form.ascites + form.bl
        U = U == 0 ? 0 : U == 1 ? 1 : U >1 ? 3 : 0
        let result = U * form.ms * form.serum
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/RMII.vue